import React from 'react';
import './Pages.css';

const UserManagement = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>User Management</h1>
        <p>Manage system users</p>
      </div>
      <div className="page-content">
        <p>User management content goes here...</p>
      </div>
    </div>
  );
};

export default UserManagement;